<template>
  <div class="col-md-3">
    <form-group-input
      ref="input"
      type="text"
      :label="label"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-bairro",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  data() {
    return {
      bairro: ""
    };
  },
  computed: {
    endereco() {
      return this.$store.state.endereco;
    }
  },
  asyncComputed: {
    valueComputed() {
      let value;

      if (this.endereco.bairro) value = this.endereco.bairro;
      else value = this.value;

      this.bairro = value;

      return value;
    }
  },
  watch: {
    bairro(value) {
      this.$emit("input", value);
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/Bairro.vue